// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { FeatureChoice } from './feature-choice';
import { PricedProductType } from './priced-product-type';

/// <code-import> Place custom imports between <code-import> tags
import { EntityPropertyAnnotation, EntityTypeAnnotation } from '../entity-type-annotations';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PricedProductTypeFeatureChoice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      new EntityPropertyAnnotation('price', {
        validators: [BaseEntity.notNegativeValidator()],
      }),
      new EntityPropertyAnnotation('accountOwnedPrice', {
        validators: [BaseEntity.notNegativeValidator(true)],
        displayName: 'Inventory Price Override',
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }

  get inventoryPrice(): number {
    return this.accountOwnedPrice != null ? this.accountOwnedPrice : this.price;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK pricedProductType */
  pricedProductTypeId!: string;
  /** Guid key FK featureChoice */
  featureChoiceId!: string;
  /** Decimal */
  accountOwnedPrice?: number;
  /** Decimal */
  price!: number;
  /** Binary */
  rowVersion!: any;
  /** FK featureChoiceId */
  featureChoice!: FeatureChoice;
  /** FK pricedProductTypeId */
  pricedProductType!: PricedProductType;
}

